import React from 'react';
import { babyKids as babyKidsData } from '../../SizeGuideData';
import { renderTableByColumns } from '../../size_guide_helpers';

const babyKids = () => [
  { tab: 'tab_clothing', label: 'Clothing', contentGenerator: () => renderTableByColumns(babyKidsData.clothing, 2) },
  { tab: 'tab_shoes', label: 'Shoes', contentGenerator: () => renderTableByColumns(babyKidsData.shoes, 1) },
  { tab: 'tab_hats', label: 'Hats', contentGenerator: () => renderTableByColumns(babyKidsData.hats, 1) },
];

export default babyKids;
